import React from 'react';
import { Circle, Line, LoadingHeader } from './styles';

export default function MessageHeaderLoading() {
  return (
    <LoadingHeader>
      <Circle className='loading-animation'></Circle>
      <Line className='loading-animation'></Line>
    </LoadingHeader>
  );
}
